function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBrowseFilterIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "tabler-icon-adjustments"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M4.00033 8.00008C3.6467 8.00008 3.30756 7.85961 3.05752 7.60956C2.80747 7.35951 2.66699 7.02037 2.66699 6.66675C2.66699 6.31313 2.80747 5.97399 3.05752 5.72394C3.30756 5.47389 3.6467 5.33341 4.00033 5.33341M4.00033 8.00008C4.35395 8.00008 4.69309 7.85961 4.94313 7.60956C5.19318 7.35951 5.33366 7.02037 5.33366 6.66675C5.33366 6.31313 5.19318 5.97399 4.94313 5.72394C4.69309 5.47389 4.35395 5.33341 4.00033 5.33341M4.00033 8.00008V13.3334M4.00033 5.33341V2.66675M8.00033 12.0001C7.6467 12.0001 7.30756 11.8596 7.05752 11.6096C6.80747 11.3595 6.66699 11.0204 6.66699 10.6667C6.66699 10.3131 6.80747 9.97399 7.05752 9.72394C7.30756 9.47389 7.6467 9.33341 8.00033 9.33341M8.00033 12.0001C8.35395 12.0001 8.69309 11.8596 8.94313 11.6096C9.19318 11.3595 9.33366 11.0204 9.33366 10.6667C9.33366 10.3131 9.19318 9.97399 8.94313 9.72394C8.69309 9.47389 8.35395 9.33341 8.00033 9.33341M8.00033 12.0001V13.3334M8.00033 9.33341V2.66675M12.0003 6.00008C11.6467 6.00008 11.3076 5.85961 11.0575 5.60956C10.8075 5.35951 10.667 5.02037 10.667 4.66675C10.667 4.31313 10.8075 3.97399 11.0575 3.72394C11.3076 3.47389 11.6467 3.33341 12.0003 3.33341M12.0003 6.00008C12.3539 6.00008 12.6931 5.85961 12.9431 5.60956C13.1932 5.35951 13.3337 5.02037 13.3337 4.66675C13.3337 4.31313 13.1932 3.97399 12.9431 3.72394C12.6931 3.47389 12.3539 3.33341 12.0003 3.33341M12.0003 6.00008V13.3334M12.0003 3.33341V2.66675",
    stroke: "#475467",
    style: {
      stroke: "#475467",
      stroke: "color(display-p3 0.2798 0.3309 0.4026)",
      strokeOpacity: 1
    },
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrowseFilterIcon);
export default __webpack_public_path__ + "static/media/browse-filter-icon.e0b763b6e395a56d14813cc62c2698b6.svg";
export { ForwardRef as ReactComponent };